import { useCallback } from 'react';
import { countriesApi } from '../api/countries.api';
import { COUNTRY_HIERARCHY_MULTI_SELECT_KEY } from '../hooks/queryKeys';
import type { Country } from '../types/countries.types';
import { HierarchyMultiSelect } from '@/shared/components/ahkinia/HierarchyMultiSelect';
import type {
  HierarchyFetchParams,
  HierarchyMultiSelectProps,
} from '@/shared/components/ahkinia/HierarchyMultiSelect';

type CountryHierarchyMultiSelectProps = Omit<
  HierarchyMultiSelectProps<Country>,
  'fetchItems' | 'fetchItemById' | 'getLabel' | 'getParent' | 'queryKey'
>;

export function CountryHierarchyMultiSelect(props: CountryHierarchyMultiSelectProps) {
  const fetchItems = useCallback(
    async ({ parentId, page = 1, pageSize = 100 }: HierarchyFetchParams) => {
      const result = await countriesApi.getCountries({
        parentId,
        isActive: true,
        page,
        pageSize,
      });
      return { items: result.data?.items ?? [], hasMore: result.data?.hasNextPage ?? false };
    },
    [],
  );

  const fetchItemById = useCallback(async (id: string) => {
    const result = await countriesApi.getCountryById(id);
    return result.data as Country;
  }, []);

  return (
    <HierarchyMultiSelect<Country>
      {...props}
      fetchItems={fetchItems}
      fetchItemById={fetchItemById}
      getLabel={(c) => c.commonName}
      getParent={(c) => c.parentId}
      queryKey={COUNTRY_HIERARCHY_MULTI_SELECT_KEY}
    />
  );
}
